import React from 'react'

import DatePicker from 'react-date-picker'

interface IProps {
  name: string
  value: Date | Date[] | null | undefined
  onChange: (e: Date | Date[]) => void
}

const DateInput: React.FC<IProps> = (props) => {
  const { value, onChange, name } = props

  const handleChange = (e: Date | Date[]) => {
    onChange(e)
  }

  return <DatePicker name={name} onChange={(e) => handleChange(e)} value={value} locale="de-DE" />
}

export default DateInput
